function fallbackDraftLineId() {
  return `draft-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function createDraftLineId() {
  return globalThis.crypto?.randomUUID?.() || fallbackDraftLineId();
}

export function ensureDraftLineId(row) {
  if (!row || typeof row !== "object") return row;
  if (row.draft_line_id) return row;
  return {
    ...row,
    draft_line_id: createDraftLineId(),
  };
}

export function draftLineId(row) {
  return row?.draft_line_id || null;
}

export function sameDraftLine(row, lineId) {
  const rowLineId = draftLineId(row);
  return !!rowLineId && !!lineId && rowLineId === lineId;
}
